import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import GlobalSchema from "./components/Schema/GlobalSchema";// 1. IMPORT GLOBAL SCHEMA DI SINI

// Placement Test
import LandingPage from "./pages/placement/LandingPage";
import BiodataPage from "./pages/placement/BiodataPage";
import TestPage from "./pages/placement/TestPage";
import ResultPage from "./pages/placement/ResultPage";

// IELTS
import WelcomePage from "./pages/ielts/WelcomePage";
import ReadingPreviewPage from "./pages/ielts/reading/ReadingPreviewPage";
import ReadingSoalPage from "./pages/ielts/reading/ReadingSoalPage"; 
import ReadingHasilPage from "./pages/ielts/reading/ReadingHasilPage"; 

import ListeningPreviewPage from "./pages/ielts/listening/ListeningPreviewPage";
import ListeningSoalPage from "./pages/ielts/listening/ListeningSoalPage";

import SpeakingPreviewPage from "./pages/ielts/speaking/SpeakingPreviewPage";
import SpeakingSoalPage from "./pages/ielts/speaking/SpeakingSoalPage";
import SpeakingHistoryPage from "./pages/ielts/speaking/SpeakingHistoryPage";
import WritingPreviewPage from "./pages/ielts/writing/WritingPreviewPage";

// Lainnya
import Login from "./pages/loginpage";
import Main from "./pages/Main";
import AboutUsPage from "./pages/AboutUsPage";
import BlogPage from "./pages/BlogPage";
import ReadinessChecker from "./pages/ReadinessChecker";
import PlacementIntro from "./components/beranda/readiness_Check/PlacementIntro";
import { Maintenance } from "./pages/Maintenance";
import ProtectedRoute from "./components/ProtectedRoute";
import { AudioPlayerProvider } from "./context/audioPlayerContext";
// Products
import Produk1 from "./pages/produk/Produk1";
import Produk2 from "./pages/produk/Produk2";

const MAINTENANCE_MODE = false;

const App = () => {
  const { pathname } = useLocation();
  const isReadinessRoute = pathname.startsWith("/readiness-checker");
  const isBiodataRoute = pathname === "/biodata";
  const isResultRoute = pathname === "/result";
  const isSpeakingHistoryRoute = pathname === "/speaking/history";

  return (
    <div className={`flex flex-col ${isResultRoute || isSpeakingHistoryRoute ? "min-h-fit bg-[--st-color-cream]" : "min-h-screen bg-custom-bg"}`}>
      
      {/* 2. PANGGIL KOMPONEN DI SINI (Sebelum Header) */}
      <GlobalSchema /> 

      <Header />
      <main className={`${isResultRoute || isSpeakingHistoryRoute ? "flex-none" : "flex-grow"} ${isReadinessRoute || isBiodataRoute || isResultRoute ? "st-surface-cream" : ""}`}>
        <Routes>
          {/* Home & Auth */}
          <Route path="/" element={<Main />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/readiness-checker/placement-intro" element={<PlacementIntro />} />
          <Route path="/readiness-checker" element={<ReadinessChecker />} />

          {/* Placement Test */}
          <Route path="/PlacementTest" element={<LandingPage />} />
          <Route path="/biodata" element={<BiodataPage />} />
          <Route path="/test" element={<TestPage />} />
          <Route path="/result" element={<ResultPage />} />

          {/* Lainnya */}
          <Route path="/produk/KelasPrivate" element={<Produk1 />} />
          <Route path="/produk/KelasIntensif" element={<Produk2 />} />
          <Route path="/writing-test" element={<WritingPreviewPage />} />
          
          {MAINTENANCE_MODE ? (
            <>
              <Route path="/maintenance" element={<Maintenance />} />
              <Route
                path="*"
                element={<Navigate to="/maintenance" replace />}
              />
            </>
          ) : (
            <>
              {/* IELTS */}
              <Route
                path="/IELTSTest"
                element={
                  <ProtectedRoute>
                    <WelcomePage />
                  </ProtectedRoute>
                }
              />

              {/* Reading */}
              <Route
                path="/reading-test"
                element={
                  <ProtectedRoute>
                    <ReadingPreviewPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/reading/soal"
                element={
                  <ProtectedRoute>
                    <ReadingSoalPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/reading/hasil"
                element={
                  <ProtectedRoute>
                    <ReadingHasilPage />
                  </ProtectedRoute>
                }
              />

              {/* Listening */}
              <Route
                path="/listening-test"
                element={
                  <ProtectedRoute>
                    <ListeningPreviewPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/listening/soal"
                element={
                  <ProtectedRoute>
                    <AudioPlayerProvider>
                      <ListeningSoalPage />
                    </AudioPlayerProvider>
                  </ProtectedRoute>
                }
              />

              {/* Speaking */}
              <Route
                path="/speaking-test"
                element={
                  <ProtectedRoute>
                    <SpeakingPreviewPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/speaking/soal"
                element={
                  <ProtectedRoute>
                    <SpeakingSoalPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/speaking/history"
                element={
                  <ProtectedRoute>
                    <SpeakingHistoryPage />
                  </ProtectedRoute>
                }
              />
            </>
          )}
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

export default App;